import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'echarts'
import './common/plugins/element.js'
import Install from './common/plugins/app'
import {tokenCache} from "./common/lib/cache/Token";
import VChart from "vue-echarts"
import Print from '@mathewparet/vue-print'
import VueClipboard from 'vue-clipboard2';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
/*
*
import VChart from "vue-echarts"
import Print from '@mathewparet/vue-print'
* */

Vue.component('v-chart', VChart);
Vue.use(Print);

//window.onresize = () => location.reload();
window.bus = new Vue();
Vue.use(Install);

// eslint-disable-next-line no-undef
Log('env', process.env);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  const token = tokenCache.get();
  // eslint-disable-next-line no-undef
  Log('token', token, to);
  if (token || to.meta.needLogin === false) {
    next();
  } else if (to.path.indexOf('/tj') === 0) {
    //next();
    next('/account/tj/login?callback=' + encodeURIComponent(to.fullPath));
  } else next('/account/login?callback=' + encodeURIComponent(to.fullPath));
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
